import { render, staticRenderFns } from "./CarrierAccountItem.vue?vue&type=template&id=4d5b8140"
import script from "./CarrierAccountItem.vue?vue&type=script&lang=ts"
export * from "./CarrierAccountItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports